import { render, staticRenderFns } from "./BankAdmin.vue?vue&type=template&id=3d8cea7c&scoped=true&"
import script from "./BankAdmin.vue?vue&type=script&lang=js&"
export * from "./BankAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BankAdmin.vue?vue&type=style&index=0&id=3d8cea7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8cea7c",
  null
  
)

export default component.exports